import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloAcabamento } from "../models/acabamento";
import { Repositorio } from "./repositorio";

export class RepositorioAcabamento extends Repositorio<ModeloAcabamento> {
  constructor() {
    super(ConstanteGlobal.ACABAMENTO);
  }
}
